import { ArrowUpRightIcon } from '../../WebsiteIcons';
import { websiteMedia as media, websiteImageProps } from '../../../util/website_media';
import React, { useEffect, useState } from 'react';
import { useReducedMotion } from 'framer-motion';
import HomepageReveal from './HomepageReveal';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { openProjectModalWithInfo } from '../../../actions/landing_page_actions';

const heroPhotos = [
  [media.nashArchitecturalExterior.src, media.nashArchitecturalExterior.alt],
  [media.terraceChefKitchen.src, media.terraceChefKitchen.alt],
  [media.mianusGardenLiving.src, media.mianusGardenLiving.alt],
  [media.waterfrontLounge.src, media.waterfrontLounge.alt],
  [media.lochFireplaceStraight.src, media.lochFireplaceStraight.alt]
];

const Hero = styled.section`
  position: relative;
  z-index: 1;
  max-width: 1360px; margin: 36px auto 0; padding: 0 40px; color: #1b264f;
  .hero-layout { display: grid; grid-template-columns: 1fr 1.08fr; align-items: center; gap: 56px; min-height: 570px; }
  .hero-eyebrow { font: 700 14px/1.5 'Poppins', sans-serif; letter-spacing: 0; text-transform: none; color: #52617e; margin: 0 0 22px; }
  .hero-google-stars { color: #a66c00; font-size: 16px; white-space: nowrap; }
  .hero-google-stars span { color: #52617e; font-size: 14px; }
  .hero-proof-divider { margin: 0 5px; }
  h1 { font: 600 clamp(36px, 3.8vw, 56px)/1.13 'Poppins', sans-serif; letter-spacing: -.045em; margin: 0 0 24px; color: #1b264f; }
  h1 span { color: #2c5bff; }
  .hero-description { font: 400 19px/1.65 'Nunito Sans', sans-serif; color: #52617e; max-width: 470px; margin: 0 0 22px; }
  .hero-promise { font: 700 16px/1.5 'Nunito Sans', sans-serif; margin: 0 0 28px; }
  .hero-promise span { color: #2c5bff; margin-right: 8px; }
  .hero-actions { display: flex; align-items: center; gap: 24px; flex-wrap: wrap; }
  .hero-primary, .hero-secondary { font: 600 15px/1.5 'Poppins', sans-serif; text-decoration: none; }
  .hero-primary { background: #2c5bff; color: white; border: 0; border-radius: 8px; padding: 18px 26px; cursor: pointer; }
  .hero-primary:hover { background: #2049d6; }
  .hero-secondary { color: #1b264f; padding: 14px 0; background: none; border: 0; cursor: pointer; }
  .hero-secondary:hover { text-decoration: underline; }
  button:focus-visible, a:focus-visible { outline: 3px solid #2c5bff; outline-offset: 5px; }
  .hero-photo-frame { position: relative; height: 570px; border-radius: 16px; overflow: hidden; background: #edf2f7; }
  .hero-image { position: absolute; inset: 0; display: block; width: 100%; height: 100%; object-fit: cover; object-position: 55% center; opacity: 0; transition: opacity 1.1s ease; }
  .hero-image.is-active { opacity: 1; }
  @media (prefers-reduced-motion: reduce) { .hero-image { transition: none; } }
  @media (max-width: 991px) {
    padding: 0 40px;
    .hero-layout { gap: 28px; }
    .hero-photo-frame { height: 510px; }
    .hero-actions { gap: 12px; }
  }
  @media (max-width: 767px) {
    margin-top: 28px; padding: 0 20px;
    .hero-layout { grid-template-columns: 1fr; gap: 28px; min-height: 0; }
    .hero-eyebrow { margin-bottom: 14px; font-size: 13px; }
    h1 { font-size: clamp(34px, 8.5vw, 48px); max-width: 560px; margin-bottom: 18px; }
    .hero-description { font-size: 17px; margin-bottom: 16px; }
    .hero-promise { font-size: 15px; margin-bottom: 20px; }
    .hero-photo-frame { height: 330px; border-radius: 12px; }
    .hero-actions { gap: 20px; }
    .hero-primary { padding: 16px 20px; }
  }
`;

const CreativeServicesComponent = (props) => {
  const [activePhoto, setActivePhoto] = useState(0);
  const [interacting, setInteracting] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (interacting || reduceMotion) return;
    const timer = window.setInterval(() => {
      if (!document.hidden) setActivePhoto(index => (index + 1) % heroPhotos.length);
    }, 5000);
    return () => window.clearInterval(timer);
  }, [interacting, reduceMotion]);
  const onGetStarted = () => {
    if (props.currentUser) props.history.push('/create-project');
    else props.openProjectModalWithInfo(null);
  };
  return (
    <Hero aria-labelledby="homepage-hero-title">
      <div className="hero-layout">
        <HomepageReveal delay={0.1}><div>
          <p className="hero-eyebrow"><span className="hero-google-stars" aria-label="5 stars on Google">★★★★★ <span>Google</span></span><span className="hero-proof-divider" aria-hidden="true"> / </span><span>2,000+ happy customers</span></p>
          <h1 id="homepage-hero-title">Real Estate Media That Makes Listings <span>Stand Out.</span></h1>
          <p className="hero-description">Professional photography, video, drone, floor plans and more—handled from booking to delivery.</p>
          <p className="hero-promise"><span aria-hidden="true">✓</span>All media delivered within 24 hours.</p>
          <div className="hero-actions">
            <button type="button" className="hero-primary" onClick={onGetStarted}>Schedule a Shoot</button>
            <button type="button" className="hero-secondary" onClick={onGetStarted}>View Pricing <span aria-hidden="true"><ArrowUpRightIcon/></span></button>
          </div>
        </div></HomepageReveal>
        <HomepageReveal delay={0.2}><div className="hero-photo-frame" role="region" aria-label="Listing photography" aria-roledescription="carousel" onMouseEnter={() => setInteracting(true)} onMouseLeave={() => setInteracting(false)}>
          {heroPhotos.map(([src, alt], index) => <img {...websiteImageProps(src, '(max-width: 767px) calc(100vw - 40px), (max-width: 1360px) 50vw, 640px')} key={src} className={'hero-image' + (index === activePhoto ? ' is-active' : '')} src={src} alt={index === activePhoto ? alt : ''} aria-hidden={index !== activePhoto} loading={index === 0 ? 'eager' : 'lazy'} />)}
        </div></HomepageReveal>
      </div>
    </Hero>
  );
};
const msp = (state) => ({ currentUser: state.session.currentUser ? state.entities.users[state.session.currentUser.id] : null });
const mdp = (dispatch) => ({ openProjectModalWithInfo: (info) => dispatch(openProjectModalWithInfo(info)) });
export default withRouter(connect(msp, mdp)(CreativeServicesComponent));